import React from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import Icon from '../../controls/icon/icon';
import "./authAside.scss"

const T_PREFIX: string = 'pages.authAside.merchantNumber.';

const AuthAsideMerchantNumber: React.FC = () => {
  const { t } = useTranslation();

    return (
        <div className="platform-section" style={{ maxWidth: `23rem`  }}>
            <div className="row">
                <div className="col-md-12">
                    <h1 className="platform-title">
                        <span>{t(`${T_PREFIX}title`)}</span> {t(`${T_PREFIX}subtitle`)}
                    </h1>

                </div>
                <div className="col-md-12">
                    <div className="platform-step">
                        <span className="material-symbols-outlined icon"><Icon name="arrow_forward" /></span>
                        <div>
                            <p>{t(`${T_PREFIX}section.description`)}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="platform-step">
                        <span className="material-symbols-outlined icon"><Icon name="arrow_forward"  /></span>
                        <div>
                            <p>{t(`${T_PREFIX}section2.description`)}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="platform-step">
                        <span className="material-symbols-outlined icon"><Icon name="arrow_forward"  /></span>
                        <div>
                            <p>{t(`${T_PREFIX}section3.description`)}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <a className="button v-primary content pt-5 d-flex d-aling-items-center cursor-pointer">
                        {t(`${T_PREFIX}learnMore`)} <span className="material-symbols-outlined ms-2"><Icon name="arrow_right_alt"  /></span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default (AuthAsideMerchantNumber);